import React, { useState, useEffect } from 'react';
import Banner from './banner/Banner';
import Products from './products/Product';
// import Recommend from './recommend/Recommend';
// import Discover from './discover/Discover';
import Favourites from './products/favourite/Favourites';
import Header from '../../components/header';
import Footer from '../../components/footer';
import { Helmet } from "react-helmet-async";
import { Container } from 'react-bootstrap';
import FooterContentSection from '../../components/FooterContentSection';

function Home({ seoData }) {
  // { searchValue, setSearchValue }
 

  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

 
  return (
    <div className="custom-font">
      <Helmet>
        <title>{seoData?.metaTitle ?? "Home"}</title>
        <meta name="description" content={seoData?.metaDescription ?? "All in one market place to Buy and sell second-hand GPUs at the best prices"} />
        {seoData?.metaImage && <meta property="og:image" content={seoData?.metaImage} />}
      </Helmet>
      <Header />
      {isLoading ? (
        <div className="loader-icon" style={{ marginBlock: "80px" }}>
          <i
            class="fa-solid fa-spinner fa-spin-pulse"
            style={{ marginBottom: "100%" }}
          ></i>
        </div>
      ) : (
        <>
          <Container className="mt-4">
            <div
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '10px',
              }}
            >
              <h1
                style={{
                  margin: 0,
                  marginBottom: isMobile ? '5px' : '5px',
                  fontSize: isMobile ? '20px' : '24px',
                  fontWeight: '600',
                  color: '#333333',
                  lineHeight: '1.3',
                }}
              >
                Buy & Sell Graphics Cards with Live Bid/Ask Pricing
              </h1>
              <p
                style={{
                  margin: 0,
                  fontSize: isMobile ? '14px' : '16px',
                  color: '#333333',
                  lineHeight: '1.6',
                }}
              >
               Trade GPUs like stocks. GPUwiz physically inspects every product sold to ensure consistent quality, so you can buy or sell at live market prices with confidence.
              </p>
            </div>
          </Container>
          <Banner />
          <Products />
          <Favourites />
        </>
      )}
        <Container style={{ marginTop: '0px', marginBottom: '0px' }}>
          <FooterContentSection />
        </Container>
      <Footer />
    </div>
  )
}

export default Home